import { ContactsEmptyState } from '../contacts/elements/ContactsEmptyState'

export const ClientsEmptyState = () => <ContactsEmptyState isCustomer />
